import ModelTypeConstants from 'constants/ModelTypeConstants';
import {previewPlugin} from 'notebook/notes/previews/PreviewPluginFactory';

import EntryPreview from './EntryPreview';
import ProtocolPreview from './ProtocolPreview';

const PROTOCOL_PREVIEW_PLUGIN = previewPlugin({
  type: ModelTypeConstants.PROTOCOL,
  preview: ProtocolPreview,
});

const ENTRY_PREVIEW_PLUGIN = previewPlugin({
  type: ModelTypeConstants.ENTRY,
  preview: EntryPreview,
});

export const NOTEBOOK_PREVIEW_PLUGINS = [PROTOCOL_PREVIEW_PLUGIN, ENTRY_PREVIEW_PLUGIN];
